import axios from "axios";

let cache = null;
let promise = null;
const DB_NAME = process.env.REACT_APP_DB_NAME;

export const getCategoryIdByName = async (name) => {
	if (cache) {
		const found = cache.find((c) => c.name === name);
		return found?.id || null;
	}
	if (!promise) {
		promise = axios
			.get("/api_w/postcategories", {
				headers: { db_name: DB_NAME },
			})
			.then((res) => {
				cache = res.data.data || [];
				return cache;
			});
	}
	const categories = await promise;
	const found = categories.find((c) => c.name === name);
	return found?.id || null;
};
